import React from 'react'
import { Image } from 'react-native'

import { Stack } from '@zet/design-system/layout'
import { CTN } from '@zet/design-system/typography'
import Constants from 'expo-constants'
import { LinearGradient } from 'expo-linear-gradient'

import logo from '../../../assets/logo.png'

const Footer = ({ position = 'left' }) => {
  return (
    <LinearGradient
      colors={['#ffffff', '#ebf3ff']}
      start={[0, 0]}
      end={[0, 1]}
      className="pb-4"
    >
      <Stack className="border-grays-30 mx-3 my-3 border-t"></Stack>
      <CTN
        className={`text-grays-8 mx-3 ${
          position == 'center' ? 'text-center' : 'text-left'
        }`}
      >
        version {Constants.expoConfig?.version} powered by
      </CTN>
      <Stack
        className={`mx-3 ${
          position == 'center' ? 'items-center' : 'items-start'
        }`}
      >
        <Image
          source={logo}
          resizeMode="contain"
          style={{ height: 30, width: 120 }}
        />
      </Stack>
    </LinearGradient>
  )
}

export default Footer
